export const STANDARD_SIGNALR_EVENTS = {
  onBackgroundTaskStatusChange: 'OnBackgroundTaskStatusChange',
};
